var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var MarketingConsentWithdrawal_1;
var _a, _b;
import { inject } from "tsyringe";
import { makeImmutable } from "../core";
import { perRestaurant } from "../di";
import { ContactDetails, ContactDetailsToken } from "./ContactDetails";
import { OrderReceiver } from "./OrderReceiver";
/**
 * Derives the contact hint to remember after a placed order so the standalone
 * marketing consent-withdrawal form (`/zgody-marketingowe`) can be pre-filled
 * with the address/number the customer subscribed with.
 */
let MarketingConsentWithdrawal = MarketingConsentWithdrawal_1 = class MarketingConsentWithdrawal {
    constructor(orderReceiver, contactDetails) {
        this.orderReceiver = orderReceiver;
        this.contactDetails = contactDetails;
        makeImmutable(this);
    }
    /**
     * Builds the contact hint to remember for the current order. Returns `null`
     * when no marketing consent was selected, in which case nothing should be
     * stored.
     */
    contactFromOrder() {
        var _a, _b, _c, _d;
        return MarketingConsentWithdrawal_1.contactFromConsents({
            consents: this.orderReceiver.consents,
            email: (_b = (_a = this.contactDetails.email) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "",
            phone: (_d = (_c = this.contactDetails.phone) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : "",
        });
    }
    /**
     * Keeps only the channels the customer actually gave a marketing consent for
     * (restaurant or Restaumatic) — the withdrawal form should offer to withdraw
     * exactly what was subscribed. Returns `null` when no marketing consent was
     * selected.
     */
    static contactFromConsents(params) {
        const { consents } = params;
        const savesEmail = consents.subscribeEmail || consents.subscribeRestaumaticEmail;
        const savesPhone = consents.subscribePhone || consents.subscribeRestaumaticPhone;
        if (!savesEmail && !savesPhone) {
            return null;
        }
        return {
            email: savesEmail ? params.email : "",
            phone: savesPhone ? params.phone : "",
        };
    }
};
MarketingConsentWithdrawal = MarketingConsentWithdrawal_1 = __decorate([
    perRestaurant(),
    __param(1, inject(ContactDetailsToken)),
    __metadata("design:paramtypes", [typeof (_a = typeof OrderReceiver !== "undefined" && OrderReceiver) === "function" ? _a : Object, typeof (_b = typeof ContactDetails !== "undefined" && ContactDetails) === "function" ? _b : Object])
], MarketingConsentWithdrawal);
export { MarketingConsentWithdrawal };
